import axios from "axios";
import { CONFIG } from "../../config";

export const getFavorites = async (memberId: string) => {
  const result = await axios.get(`${CONFIG.API_URL}/c/m/favorite/${memberId}`);

  return result?.data;
};
